<!-- 开票订单数据操作 -->
<template>
  <div>
    <div class="demo-drawer__content data_action_form">
      <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
        <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
          <template slot="tabs" slot-scope="scope">
            <div class="table_content_box">
              <!-- 提取信息 -->
              <div v-if="scope.index == 0">
                <div id="mainInfo">
                  <el-form label-width="100px" style="padding-bottom: 10px;" class="baseForm" :model="invoiceExtractData" ref="invoiceExtractData" size="mini" :show-message="false" :disabled="dataActionBox.actionType == 1">
                    <el-row>
                      <el-form-item v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" :label="formOneValue.showField" :prop="formOneValue.entityField"
                        :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                        <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                        <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item" :disabled="invoiceExtractData[formOneValue.entityField]==null||invoiceExtractData[formOneValue.entityField]==''?true:false || invoiceExtractData[formOneValue.entityField].length<=9" effect="dark"
        :content="invoiceExtractData[formOneValue.entityField]" placement="bottom-start">
                        <el-input class="form_codition" clearable
                          :disabled="dataActionBox.actionType == 2 || sendDataInfo.psdocumentsmasterList.length>0 || sendDataInfo.psdocumentsdetailList.length>0" v-model="invoiceExtractData[formOneValue.entityField]"
                          @keyup.enter.native="openSearch(formOneValue.searchId, 0, formOneValue.entityField, formOneValue.setField)">
                          <el-button :disabled="dataActionBox.actionType == 2 || sendDataInfo.psdocumentsmasterList.length>0 || sendDataInfo.psdocumentsdetailList.length>0"
                            @click="openSearch(formOneValue.searchId, 0, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button></el-input>
                        </el-tooltip>
                            <el-input :disabled="dataActionBox.actionType == 2 || sendDataInfo.psdocumentsmasterList.length>0 || sendDataInfo.psdocumentsdetailList.length>0" v-else v-model.trim="invoiceExtractData[formOneValue.entityField]"
                          :maxlength="$store.state.inputLength"></el-input>

                      </el-form-item>
                      <el-form-item v-if="dataActionBox.actionType == 2" label="总金额">
                        <el-input :disabled="dataActionBox.actionType == 2 || sendDataInfo.psdocumentsmasterList.length>0 || sendDataInfo.psdocumentsdetailList.length>0" v-model="purtotalMoeny"></el-input>
                      </el-form-item>
                    </el-row>
                  </el-form>
                </div>
                <el-row>
                  <el-col :span="12" style="padding-right:10px">
                    <!-- 采购订单数据 -->
                    <div id="operateBtn" style="display: flex;justify-content: space-between;margin: 0 10px; align-items: center;">
                      <div v-if="dataActionBox.actionType == 0">
                        <el-button type="danger" size="mini" @click="delPurData">删除</el-button>
                        <el-button type="primary" size="mini" @click="getExtractpur">选择单据</el-button>
                      </div>
                      <span v-if="dataActionBox.actionType == 2">采购订单数据</span>
                      <span v-if="dataActionBox.actionType == 0" style="margin-left: 40px;">采购订单数据</span>
                      <span v-if="dataActionBox.actionType == 0">总金额：<span style="color:red">{{
                        purtotalMoeny }}</span></span>
                    </div>
                    <div style="height: 5px;"></div>
                    <el-table :data="sendDataInfo.psdocumentsmasterList" border size="mini" :height="mxHeight" ref="psdocumentsmasterTable">
                      <el-table-column label="选择操作" width="80">
                        <template slot-scope="scope">
                          <el-radio v-model="selectedpurDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                          </el-radio>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in formDataDetailList[0].jurconfigform"
                        :key="formOneKey" show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                        <template slot-scope="scope">
                          <input class="settleInput" @input="changeMoney($event, scope.$index, 'psdocumentsmasterList')" :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'settleMoney' && dataActionBox.actionType == 0"
                            type="number" v-model="sendDataInfo.psdocumentsmasterList[scope.$index].settleMoney" />
                          <span v-else>{{ sendDataInfo.psdocumentsmasterList[scope.$index][formOneValue.entityField]
                          }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                  <el-col :span="12">
                    <div id="operateBtn" style="display: flex;justify-content: space-between;margin: 0 10px; align-items: center;">
                      <div v-if="dataActionBox.actionType == 0">
                        <el-button type="danger" size="mini" @click="delSaleData">删除</el-button>
                        <el-button type="primary" size="mini" @click="getExtractsale">选择单据</el-button>
                      </div>
                      <span v-if="dataActionBox.actionType == 2">销售订单数据</span>
                      <span v-if="dataActionBox.actionType == 0" style="margin-left: 40px;">销售订单数据</span>
                      <span v-if="dataActionBox.actionType == 0">总金额：<span style="color:red">{{
                        saletotalMoeny }}</span></span>
                    </div>
                    <div style="height: 5px;"></div>
                    <el-table :data="sendDataInfo.psdocumentsdetailList" :row-style="rowStyle" border size="mini" :height="mxHeight" ref="psdocumentsdetailTable">
                      <el-table-column label="选择操作" width="80">
                        <template slot-scope="scope">
                          <el-radio v-model="selectedSaleDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                          </el-radio>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in formDataDetailList[1].jurconfigform" :key="formOneKey"
                        show-overflow-tooltip :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow == 1">
                        <template slot-scope="scope">
                          <input @input="changeMoney($event, scope.$index, 'psdocumentsdetailList')" class="settleInput" v-if="formOneValue.entityField == 'settleMoney' && dataActionBox.actionType == 0" type="number"
                            :disabled="dataActionBox.actionType == 2" v-model="sendDataInfo.psdocumentsdetailList[scope.$index].settleMoney" />
                          <span v-else>{{ sendDataInfo.psdocumentsdetailList[scope.$index][formOneValue.entityField]
                          }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-col>
                </el-row>
              </div>
              <!-- 明细信息 -->
            </div>
          </template>
        </v-tabs>
      </el-card>
      <v-foot :actionType="dataActionBox.actionType" :flag="false" @initActionBox="initActionBox" @sendDataAction="sendDataAction"></v-foot>
      <!-- <div class="foot">
        <div style="margin-top: 10px;text-align: center;">
          <el-button v-if="dataActionBox.actionType == 0" type="primary"
            @click="initActionBox('sendDataInfo', 'invoiceExtractData')">取消
          </el-button>
          <el-button type="primary" @click="sendDataAction('sendDataInfo', 'invoiceExtractData')"
            v-if="dataActionBox.actionType == 0">保存</el-button>
        </div>
      </div> -->
    </div>
    <!-- 检索方案 -->
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" append-to-body>
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 提取方案 -->
    <el-dialog top="1vh" title="提取采购表单" v-if="DialogExtract" :visible.sync="DialogExtract" width="100%" append-to-body>
      <ExtractionPurPaymentApply :extractParamsData="invoiceExtractData" :id="553755277398016" ref="ExtractionPurPaymentApply" :parentData="parentData" :invoiceExtractData="invoiceExtractData" @invoiceExtractMethods="getExData" />
    </el-dialog>
    <el-dialog top="1vh" title="提取销售表单" v-if="DialogExtract1" :visible.sync="DialogExtract1" width="100%" append-to-body>
      <ExtractionPurPaymentApply :isOutCoId="true" :extractParamsData="invoiceExtractData" :id="553755277398017" ref="ExtractionPurPaymentApply" :parentData="parentData" :invoiceExtractData="invoiceExtractData" @invoiceExtractMethods="getExData" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue";
import PurchaseInvoiceExtract from '../byComponents/PurchaseInvoiceExtract'
import ExtractionPurPaymentApply from "../byComponents/ExtractionPurPaymentApply.vue";
export default {
  name: 'receOffsetPayAction',
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    PurchaseInvoiceExtract, ExtractionPurPaymentApply
  },
  data() {
    //这里存放数据
    return {
      tableKey: 0,
      mxHeight: 0,
      selectedpurDataIndex: 0,
      selectedSaleDataIndex: 0,
      formDataDetailList: [],
      dataActionBox: {
        showStatus: false,
        openMode: 'ltr' || 'rtl',
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      parentData: {},
      invoiceExtractData: {
        coName: '', //货主
        smName: '', //单位
        start: '',
        end: '',
        cmName: "",
        cmId: "",
        outcoName:""
      },
      purtotalMoeny: 0,
      saletotalMoeny: 0,
      parentSearchData: {},
      sendDataInfo: {
        psdocumentsdetailList: [],
        psdocumentsmasterList: [],
        railNum: "", //轨号
        remark: "", //备注
        ticketNum: "", //发票号
        poolMoney: 0, //总额合计
        capMoeny: '', //价税合计(大写)
        poolPsmoney: 0, //价税合计 含税总额合计(小写)
        poolTaxmoney: 0, //税额合计
        billType: "",
      },
      detailSelectList: [], //明细选择数据
      showTabs: '',
      formDataList: [],
      selectedDetailsIndex: 0,
      seTitle: "", //检索
      DialogVisible: false,
      DialogExtract1: false,
      seId: 0,
      DialogExtract: false, //提取
      smId: '',
      seWidth: '0',
      mxHeight: 400, //动态表格高度
      sField: '',
      parentSearchData: {},
      inputel: [],
      type: 0,//0为采购1为销售
    };
  },
  created() {
    this.openBox(this.actionData.cate, this.actionData.formData, this.actionData.oldData)
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    //修改价格处理函数
    changeMoney(e, index, list) {
      if (this.sendDataInfo[list][index].oldBalance >= 0) {
        if (this.sendDataInfo[list][index].oldBalance < +e.target.value) {
          e.target.value = this.sendDataInfo[list][index].oldBalance
          this.sendDataInfo[list][index].settleMoney = +e.target.value
        }
        if (e.target.value < 0) {
          e.target.value = this.sendDataInfo[list][index].oldBalance
          this.sendDataInfo[list][index].settleMoney = +e.target.value
        }
      } else {
        if (this.sendDataInfo[list][index].oldBalance > +e.target.value) {
          e.target.value = this.sendDataInfo[list][index].oldBalance
          this.sendDataInfo[list][index].settleMoney = +e.target.value
        }
        if (e.target.value > 0) {
          e.target.value = this.sendDataInfo[list][index].oldBalance
          this.sendDataInfo[list][index].settleMoney = +e.target.value
        }
      }
      this.changePrice(list)
    },
    //计算总价
    changePrice(list) {
      if (list == 'psdocumentsmasterList') {
        this.purtotalMoeny = this.$common.getDecimalInfo(3, this.sendDataInfo.psdocumentsmasterList.reduce((prev, item) => {
          return prev + (+item.settleMoney || 0)
        }, 0))


      } else {
        this.saletotalMoeny = this.$common.getDecimalInfo(3, this.sendDataInfo.psdocumentsdetailList.reduce((prev, item) => {
          return prev + (+item.settleMoney || 0)
        }, 0))

      }
    },
    toDetail(orderId) {
      this.$parent.toDetail(orderId);
    },
    //删除销售订单
    delSaleData() {
      this.sendDataInfo.psdocumentsdetailList.splice(this.selectedSaleDataIndex, 1)
      this.changePrice('psdocumentsdetailList')
    },
    //删除采购订单
    delPurData() {
      this.sendDataInfo.psdocumentsmasterList.splice(this.selectedpurDataIndex, 1)
      this.changePrice('psdocumentsmasterList')

    },
    //提取销售订单
    getExtractsale() {
      this.$refs.invoiceExtractData.validate((valid) => {
        if (valid) {
          this.type = 1
          this.DialogExtract1 = true;
          this.parentData = {
            type: 'dasmId',
            list: this.sendDataInfo.psdocumentsdetailList,
          }
          console.log(this.parentData,"********",this.invoiceExtractData)
          
        }
      })
    },
    //提取采购订单
    getExtractpur() {
      this.$refs.invoiceExtractData.validate((valid) => {
        if (valid) {
          this.type = 0
          this.DialogExtract = true;
          this.parentData = {
            type: 'dapmId',
            list: this.sendDataInfo.psdocumentsmasterList
          }
        }
      })
    },
    // 获取 提取单数据
    async getExData(res) {
      let val = JSON.parse(JSON.stringify(res))
      console.log('提取', val);
      if (val != "" || val != undefined) {
        if (this.type) {
          val.mainData.forEach(item => {
            const index = this.sendDataInfo.psdocumentsdetailList.findIndex(item1 => item1.businessId == item.businessId)
            if (index == -1) {
              this.sendDataInfo.psdocumentsdetailList.push(item)
            }
          })
          this.sendDataInfo.psdocumentsdetailList.forEach(item => {
            item.settleMoney = item.oldBalance
          })
          this.changePrice('psdocumentsdetailList')

        } else {
          val.mainData.forEach(item => {
            const index = this.sendDataInfo.psdocumentsmasterList.findIndex(item1 => item1.businessId == item.businessId)
            if (index == -1) {
              this.sendDataInfo.psdocumentsmasterList.push(item)
            }
          })
          this.sendDataInfo.psdocumentsmasterList.forEach(item => {
            item.settleMoney = item.oldBalance
          })
          this.changePrice('psdocumentsmasterList')
        }
      } else { }
      this.DialogExtract = false

      this.DialogExtract1 = false
    },
    getExWidth(e) {
      this.exWidth = e + "%";
    },
    getExtractName(e) {
      this.exTitle = e;
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      this.seId = sId
      this.sField = sField
      this.parentSearchData[type] = this.invoiceExtractData[type]
      this.DialogVisible = true
    },
    //检索带回数据
    changeInputModel(val) {
      console.log('检回', val);
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.invoiceExtractData[item] = val[item]
      })
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    //确认新增
    async sendDataAction(formName1, formName2) {
      if (this.purtotalMoeny != this.saletotalMoeny) return this.$message.error('应收与应付金额不匹配，请修改后再新增')
      this.$http.addReceOffpay({
        "coId": this.invoiceExtractData.coId,
        "outcoId": this.invoiceExtractData.outcoId,
        "receOffPayPsAdds": this.sendDataInfo.psdocumentsmasterList,
        "receOffPaySuAdds": this.sendDataInfo.psdocumentsdetailList,
        "smId": this.invoiceExtractData.smId,
        "cmId": this.invoiceExtractData.cmId,
        "totalMoney": this.purtotalMoeny
      }).then(res => {
        if (res.status == 200) {
          this.$emit('closeNew')
        }
      })
    },
    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, "rowIndex", {
        // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false,
      });
      let rowBackground = {}
      if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
      return rowBackground
    },

    //取消
    initActionBox(formName1, formName2) {
      if (this.dataActionBox.actionType == 1) {
        this.$emit('closeNew')
        this.init()
        // this.$refs[formName1].resetFields()
        // this.$refs[formName2].resetFields()
      } else {
        this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit('closeNew')
          this.init()
          //   this.$refs[formName1].resetFields()
          //   this.$refs[formName2].resetFields()
        }).catch(() => { })
      }
    },

    //初始化
    init() {
      for (const key in this.invoiceExtractData) {
        this.invoiceExtractData[key] = ''
      }
      for (let key in this.sendDataInfo) {
        if (key == 'psdocumentsmasterList' || key == 'psdocumentsdetailList') {
          this.sendDataInfo[key] = []
        } else {
          this.sendDataInfo[key] = ''
        }
      }
      this.invoiceExtractData.start = (new Date().getTime() - 31 * 24 * 3600 * 1000)
      this.invoiceExtractData.end = this.$moment().valueOf()
      this.dataActionBox.actionType = 0
    },
    //上级流入
    openBox(cate, formData, oldData = '') {
      this.showTabs = formData[0].jciName
      this.formDataList = [formData[0]]
      this.formDataDetailList = [formData[1], formData[2]]
      oldData = JSON.parse(JSON.stringify(oldData))
      this.init()
      if (cate == 0) {
        this.dataActionBox.boxTitle = '新增信息'
        this.dataActionBox.openMode = 'ltr'

      } else if (cate == 2) {
        this.dataActionBox.boxTitle = '查看信息'
        this.dataActionBox.openMode = 'rtl'
        this.sendDataInfo = oldData
        this.invoiceExtractData['smId'] = oldData.smId
        this.invoiceExtractData['smName'] = oldData.smName
        this.invoiceExtractData['coName'] = oldData.coName
        this.sendDataInfo.psdocumentsmasterList = oldData.receOffPayPsAdds
        this.sendDataInfo.psdocumentsdetailList = oldData.receOffPaySuAdds
        this.changePrice("psdocumentsmasterList")
        this.changePrice("psdocumentsdetailList")
      } else {
        this.dataActionBox.boxTitle = '信息'
        this.dataActionBox.openMode = 'rtl'
        this.sendDataInfo = oldData
        this.invoiceExtractData['smId'] = oldData.smId
        this.invoiceExtractData['smName'] = oldData.smName
        this.sendDataInfo.psdocumentsmasterList = []
        this.sendDataInfo.psdocumentsdetailList = []

      }
      this.dataActionBox.actionType = cate
      this.dataActionBox.showStatus = true
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
          }
        }, 100)
      });
    },
    // 获取主表单所有input
    getMainInput() {
      var el = document.getElementById("mainInfo");
      if (el) this.inputel = el.getElementsByTagName("input");
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.getMainInput();
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
::v-deep .el-drawer .el-drawer__header {
  height: 0;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.detailForm {
  margin-bottom: 0.2rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.detailForm .el-input {
  width: auto;
}

.table_button_box {
  height: 200px;
  background-color: red;
}

/* .table_content_box {
    height: 500px !important;
    overflow-y: auto;
} */

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.foot {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  padding: 5px 0;
  z-index: 999;
}

.el-drawer {
  outline: none;
}

.kaipiao_num {
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  height: 28px;
  width: 100%;
  line-height: 40px;
  padding: 0 15px;
  outline: 0;
}

.settleInput {
  outline: none;
  border: 1px solid #dcdfe6;
  width: 100%;
  padding: 0px 15px;
  border-radius: 4px;
  height: 28px;
  line-height: 28px;
}

.settleInput:focus {
  border-color: #66b1ff;
}
</style>